export const handleNavigate = (path, hash, navigate) => {
    navigate(path);
    setTimeout(() => {
        const section = document.querySelector(hash);
        if (section) {
            section.scrollIntoView({ behavior: "smooth" });
        }
    }, 0);
};

// verify email
export const verifyEmail = (value) => {
    const emailRegex =
      /^[a-zA-Z0-9]+(?:[._-][a-zA-Z0-9]+)*@[a-zA-Z0-9]+\.[a-zA-Z]{2,}$/;
  
    return emailRegex.test(value);
  };